import { ambiente } from "../../shared/utils/Enum";
export const envConfig = {
  PUBLIC_URL: "https://dotnethml.hermespardini.com.br/onboarding/",
  REACT_APP_API_URL: "https://dotnethml-api.hermespardini.com.br/onboarding/api/v1",
  REACT_APP_NOME_AMBIENTE: ambiente.homologacao,
  REACT_APP_NAME: '$npm_package_name',
  REACT_APP_VERSION: '$npm_package_version',
  REACT_APP_URL_PAGINA_INICIAL_MY_PARDINI:
    "https://www33.mypardini.com.br/mypardini/faces/pages/dashboard.xhtml?sessionId=",
  REACT_APP_CODIGO_GOOGLE_ANALYTICS: "UA-126638394-2",
  REACT_APP_URL_JAR_IMPRESSAO: 'https://dotnethml-api.hermespardini.com.br/Print.jar',
  REACT_APP_URL_RASTREIO_AMOSTRA: 'https://dotnethml.hermespardini.com.br/logistica/?sessionId=',
  REACT_APP_URL_HELP_EXAMES: 'https://www.hermespardini.com.br/csp/HelpExamesPublico/HPardini.HelpExame.Pagina.ConsultaPubHelpExame.cls?unidadeNegocio=1&mostrarRodape=0&mostrarCab=1&layout=8&mostrarLabel=1&regiao=$REGIAO_PRODUTIVA$&tipoApoio=$TIPO_NEGOCIO$&exame=$EXAME$',
  REACT_MAPA_VUUPT: 'https://sandbox.vuupt.com/rtc/vuupt-',
  REACT_PC_DEPLOYMENT_ID: "202be4fe-91c4-4884-a6be-5cacbcb5d6a6",
  REACT_BLIP_CUSTOM_URL: "https://grupopardini.chat.blip.ai/",
  REACT_BLIP_APPKEY: "aHBsMmxiYzo1ODM4OTRiMS01ODNjLTQ4OWQtYTAyYi0xNjUxMWJjMDk4Y2Y="
};
